<template>
  <div>
    <form v-on:submit.prevent="loginClick">
      <div class="title mt-3 mb-4 text-center">
        <h1><b>Sign in</b></h1>
      </div>
      <div class="col mb-3 mt-3">
        <div class="form-floating">
          <input
            type="text"
            class="form-control"
            id="user-id"
            v-model="login.USER_ID"
            required
          />
          <label for="user-id">Username</label>
        </div>
        <div ref="USER_ID" class="check red" role="alert">&nbsp;</div>
      </div>
      <div class="col mt-3">
        <div class="form-floating input-group">
          <input
            :type="passwordToggle"
            class="form-control"
            id="passwd"
            v-model="login.PASSWD"
            required
          />
          <label for="passwd" style="z-index: 3">Password</label>
          <button
            type="button"
            class="btn border bg-white border border-radius-right rounded-end border-start-0"
            aria-label="Show/hide entered password"
            :aria-pressed="iconShowPw"
            @click="showPassword()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              class="bi bi-eye-fill"
              viewBox="0 0 16 16"
              v-show="iconShowPw"
            >
              <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
              <path
                d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              class="bi bi-eye-slash-fill"
              viewBox="0 0 16 16"
              v-show="iconHidePw"
            >
              <path
                d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z"
              />
              <path
                d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z"
              />
            </svg>
          </button>
        </div>
        <div ref="PASSWD" class="check red" role="alert">&nbsp;</div>
      </div>
      <div ref="ERRORS" class="check red" role="alert">&nbsp;</div>
      <div class="col mb-5 mt-3"></div>
      <div class="col">
        <button type="submit" class="btn btn-dark btn-lg rounded-pill w-100">
          Login
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
            v-if="loading.login"
          ></span>
        </button>
      </div>
      <div class="hr-sect"><b>or</b></div>
      <div class="col mb-5">
        <button
          type="button"
          class="btn btn-outline-dark btn-lg rounded-pill w-100"
          @click="joinClick()"
        >
          Sign up
        </button>
      </div>
      <div class="row">
        <div class="col">
          <button
            type="button"
            class="bg-white border-0"
            @click="findIdClick()"
          >
            <b>Forgot username?</b>
          </button>
        </div>
        <div class="col">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </div>
        <div class="col">
          <button
            type="button"
            class="bg-white border-0"
            @click="findPwdClick()"
          >
            <b>Forgot password?</b>
          </button>
        </div>
      </div>
    </form>
    <AddSiteUserDialog ref="addSiteUserDialog"></AddSiteUserDialog>
  </div>
</template>
<script>
import "@/assets/css/formLayout.css";
import { router } from "@/router/index.js";
import { $axios, $error, $global, $session } from "@/dot-ui/index.js";
import AddSiteUserDialog from "@/components/dialog/AddSiteUserDialog";

export default {
  data() {
    return {
      login: {
        USER_ID: "",
        PASSWD: "",
        SITE_NO: "",
        COMP_NO: ""
      },
      passwordToggle: "password",
      iconShowPw: false,
      iconHidePw: true,
      fromParams: "",
      loading: {
        login: false,
      },
    };
  },
  components: {
    AddSiteUserDialog,
  },
  created() {
    this.fromParams = $global.getUrlParams();
  },
  methods: {
    //When checkbox clicked show password
    showPassword() {
      this.passwordToggle =
        this.passwordToggle === "password" ? "text" : "password";
      this.iconShowPw = this.iconShowPw === true ? false : true;
      this.iconHidePw = this.iconHidePw === false ? true : false;
    },
    // 로그인 클릭
    loginClick() {
      // 클래스(.check) 폼 초기화
      $error.clearForm("check");

      let self = this;
      // ?callback=[로그인 후 콜백 URL]&s=[사이트번호]&c=[업체번호]
      // let fromParams = $global.getUrlParams();
      let fromSiteNo = this.fromParams.s;
      let fromCompNo = this.fromParams.c;

      // 업체번호 못가져오는 경우 다시 조회 처리 (2022-10-17 / 정태화)
      if (fromCompNo == "" || fromCompNo == "undefined") {
        let domain = $global.getDomain(this.fromParams.cb);
        $global.getCompNo(domain, function (compNo) {
          self.loginProcess(fromSiteNo, compNo);
        });
      } else {
        self.loginProcess(fromSiteNo, fromCompNo);
      }
    },
    // 로그인 처리
    async loginProcess(fromSiteNo, fromCompNo) {
      this.loading.login = true;
      let url = "/user-app/v2/auth/login";
      this.login.SITE_NO = fromSiteNo;
      this.login.COMP_NO = fromCompNo;
      let param = this.login;
      let response = await $axios.post(url, param);
      this.loading.login = false;

      if (response.status == 200) {
        let json = response.data;
        // (1) 로그인 성공한 경우
        if (json.RESULT_CODE == "12") {
          this.loginCallback();
          // (2) 닷사용자 이지만, 사이트 사용자가 아닌 경우
        } else if (json.RESULT_CODE == "11") {
          this.$refs.addSiteUserDialog.open(fromSiteNo, fromCompNo, json);
        }
      } else {
        $error.showMessage(response, this);
        document.getElementById("user-id").focus();
      }
    },
    // 메세지 표시
    // 로그인 성공 콜백처리
    loginCallback() {
      let fromSiteNo = this.fromParams.s;
      let fromCompNo = this.fromParams.c;
      let fromCallback = this.fromParams.cb;

      // 로그인 URL 세션에 저장
      $session.setSignInUrl(fromSiteNo, fromCompNo);

      // (1) 호출한 페이지가 존재하는 경우
      if (fromCallback) {
        location.href = fromCallback
        // (2) 호출한 페이지가 없는 경우
      } else {
        router.push({
          path: "/",
          query: {
            cb: this.fromParams.cb,
            s: this.fromParams.s,
            c: this.fromParams.c,
          },
        });
      }
    },
    // 회원가입
    joinClick() {
      router.push({
        path: "/join",
        query: {
          cb: this.fromParams.cb,
          s: this.fromParams.s,
          c: this.fromParams.c,
        },
      });
    },
    // 회원ID 찾기
    findIdClick() {
      router.push({
        path: "/findId",
        query: {
          cb: this.fromParams.cb,
          s: this.fromParams.s,
          c: this.fromParams.c,
        },
      });
    },
    // 회원Pwd 찾기
    findPwdClick() {
      router.push({
        path: "/findPwd",
        query: {
          cb: this.fromParams.cb,
          s: this.fromParams.s,
          c: this.fromParams.c,
        },
      });
    },
  },
};
</script>
<style></style>
